export default __webpack_public_path__ + "static/media/sh.e1c6f435.jpg";